import React, { useState, useEffect } from 'react';

const Pagination = ({
  currentPage,
  totalItems,
  recordsPerPage,
  paginate,
}) => {
  const totalPages = Math.ceil(totalItems / recordsPerPage);
  const [maxPageButtons, setMaxPageButtons] = useState(5);

  useEffect(() => {
    const updateMaxButtons = () => {
      setMaxPageButtons(window.innerWidth < 768 ? 3 : 5);
    };

    updateMaxButtons();
    window.addEventListener('resize', updateMaxButtons);
    return () => window.removeEventListener('resize', updateMaxButtons);
  }, []);

  const getPageNumbers = () => {
    const pageNumbers = [];
    let startPage = Math.max(currentPage - Math.floor(maxPageButtons / 2), 1);
    let endPage = startPage + maxPageButtons - 1;

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(endPage - maxPageButtons + 1, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  };

  const handlePaginate = (page) => {
    paginate(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (totalPages <= 1) return null;

  const pageNumbers = getPageNumbers();

  const buttonBase =
    'px-3 py-1 rounded-md text-sm border transition-colors duration-150';
  const activeButton = 'bg-blue-600 text-white border-blue-600';
  const inactiveButton = 'bg-white text-gray-600 border-gray-300 hover:bg-gray-100';

  return (
    <div className="flex items-center justify-center flex-wrap gap-2">
      {currentPage > maxPageButtons && (
        <button
          onClick={() => handlePaginate(Math.max(currentPage - maxPageButtons, 1))}
          className={`${buttonBase} ${inactiveButton}`}
        >
          &laquo;
        </button>
      )}

      {currentPage > 1 && (
        <button
          onClick={() => handlePaginate(currentPage - 1)}
          className={`${buttonBase} ${inactiveButton}`}
        >
          &lsaquo;
        </button>
      )}

      {pageNumbers.map((number) => (
        <button
          key={number}
          onClick={() => handlePaginate(number)}
          className={`${buttonBase} ${
            currentPage === number ? activeButton : inactiveButton
          }`}
        >
          {number}
        </button>
      ))}

      {currentPage < totalPages && (
        <button
          onClick={() => handlePaginate(currentPage + 1)}
          className={`${buttonBase} ${inactiveButton}`}
        >
          &rsaquo;
        </button>
      )}

      {currentPage <= totalPages - maxPageButtons && (
        <button
          onClick={() => handlePaginate(Math.min(currentPage + maxPageButtons, totalPages))}
          className={`${buttonBase} ${inactiveButton}`}
        >
          &raquo;
        </button>
      )}
    </div>
  );
};

export default Pagination;
